import clsx from 'clsx';
import React from 'react';
import styles from './styles.module.scss';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const SectionHeader = _ref => {
  let {
    className = '',
    Icon,
    subText,
    children
  } = _ref;
  return /*#__PURE__*/_jsxs("header", {
    className: clsx(styles.container, className),
    children: [subText ? /*#__PURE__*/_jsxs("sub", {
      className: styles.subscript,
      children: [Icon ? Icon : /*#__PURE__*/_jsx(_Fragment, {}), " ", subText]
    }) : /*#__PURE__*/_jsx(_Fragment, {}), /*#__PURE__*/_jsx("h2", {
      className: styles.heading,
      children: children
    })]
  });
};

export default SectionHeader;